var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("detail", { ref: "detail", on: { detail: _vm.setDetail } }),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detail.status,
                      expression: "detail.status",
                    },
                  ],
                  staticClass: "footer-btn",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    },
                    [_vm._v("返回")]
                  ),
                  !_vm.$root.desktopWorkbench &&
                  _vm.detail.businessName &&
                  _vm.detail.businessName !== "noticeDetail"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.lookAccount()
                            },
                          },
                        },
                        [_vm._v("查看账号")]
                      )
                    : _vm._e(),
                  !_vm.$root.desktopWorkbench &&
                  _vm.detail.businessName === "noticeDetail"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.lookAnnouncement()
                            },
                          },
                        },
                        [_vm._v("查看")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.btnCommentLoading,
                      },
                      on: { click: _vm.onComment },
                    },
                    [_vm._v("评论")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnExport },
                      on: {
                        click: function ($event) {
                          return _vm.getPdf("export")
                        },
                      },
                    },
                    [_vm._v("导出")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnPrint },
                      on: {
                        click: function ($event) {
                          return _vm.getPdf("print")
                        },
                      },
                    },
                    [_vm._v("打印")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("popComment", { ref: "popComment", on: { ok: _vm.setComment } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }